import { pdpSharedNotifications } from '../PdpSharedNotifications/pdpSharedNotifications';
import { auctionSavePdpPromptConfig } from '../PdpSharedNotifications/AuctionSavePdpPromptConfig';

export const pdpRespNotifications = [...pdpSharedNotifications, auctionSavePdpPromptConfig];
